import { Stepper, StepperProps } from "app/core/components/Stepper"

export const steps: StepperProps["steps"] = [
  {
    label: "Student Info",
    href: (params) => `/mind-print/${params.orderId}/1`,
  },
  {
    label: "Billing & Checkout",
    href: (params) => `/mind-print/${params.orderId}/2`,
  },
]

export const MindprintStepper = () => {
  return <Stepper steps={steps} />
}
